import React, { useEffect, useState } from 'react'
import Drawer from 'components/shared/Drawer'
import strings from 'strings'
import { Tabs, Tab } from 'components/shared/Tabs'
import UccSearchTab  from './UccSearchTab/UccSearchTab'
import UccSearchHistoryTabContent  from './UccSearchTab/UccSearchHistoryTabContent'
import { uccSearchDrawerTabs } from 'constants/constantVariables'
import { useDispatch } from 'react-redux'
import { dispatchUpdatedUccResponse, dispatchUccSearchParameters } from 'actions/applicants'
import UccAuditTab from './UccAuditTab/UccAuditTab'
import UccAttachedFilingsTab from "./UccAttachedFilingsTab/UccAttachedFilingsTab";
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'

const uccStrings = strings.APPLICANT.UCC

const DRAWER_TAB_KEYS = ['search', 'filings', 'history', 'audit']

const UccSearchDrawer = ({ selectedEntity, applicationId, open, handleOnClose, initialTab, debtorApplication,
                             creditUsageEnabled, creditCosts, highlightSearchId }) => {

    const [initialDrawerTabValue, setInitialDrawerTabValue] = useState(initialTab || 0)
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatchUccSearchParameters(false, dispatch)
        dispatchUpdatedUccResponse(false, dispatch)
        // eslint-disable-next-line
    }, [])

    const handleDrawerTabChange = (e, value) => {
        setInitialDrawerTabValue(value)

        // Update the URL query param to reflect the active drawer tab
        const params = queryString.parse(history.location.search)
        params.uccDrawerTab = DRAWER_TAB_KEYS[value]
        // Clear highlightSearchId when navigating away from history
        if (value !== 2) {
            delete params.uccSearchId
        }
        history.replace(`${history.location.pathname}?${queryString.stringify(params)}`)
    }

    return (
        <Drawer
            title={uccStrings.UCC_SEARCH}
            onClose={handleOnClose}
            open={open}
        >
            <div className='p-3'>
                <Tabs
                    data={uccSearchDrawerTabs}
                    value={initialDrawerTabValue}
                    onChange={handleDrawerTabChange}
                />
                <Tab value={initialDrawerTabValue} index={0}>
                    <UccSearchTab
                        selectedEntity={selectedEntity}
                        applicationId={applicationId}
                        debtorApplication={debtorApplication}
                        creditUsageEnabled={creditUsageEnabled}
                        creditCosts={creditCosts}
                    />
                </Tab>
                <Tab value={initialDrawerTabValue} index={1}>
                    <UccAttachedFilingsTab
                        selectedEntity={selectedEntity}
                        applicationId={applicationId}
                        debtorApplication={debtorApplication}
                    />
                </Tab>
                <Tab value={initialDrawerTabValue} index={2}>
                    <UccSearchHistoryTabContent
                        selectedEntity={selectedEntity}
                        applicationId={applicationId}
                        debtorApplication={debtorApplication}
                        highlightSearchId={highlightSearchId}
                    />
                </Tab>
                <Tab value={initialDrawerTabValue} index={3}>
                    <UccAuditTab
                        selectedEntity={selectedEntity}
                        applicationId={applicationId}
                    />
                </Tab>
            </div>
        </Drawer >
    )
}

export default UccSearchDrawer